
'use client';

import { Header } from '@/components/header';
import { Footer } from '@/components/footer';
import { MembershipPlans } from '@/components/membership/membership-plans';

export default function MembershipPage() {
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1 container mx-auto px-4 py-8">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-headline mb-2">Membership Plans</h1>
                        <p className="text-xl text-muted-foreground">Choose the plan that's right for you.</p>
                    </div>

                    <MembershipPlans />
                </div>
            </main>
            <Footer />
        </div>
    );
}
